@if (isPublicNavigationEnabled()) {
  <div class="header-logged-out">
    <ftr-logo [theme]="logoThemes.Themed" [static]="true" />
    <button
      ftrIconButton
      icon="HelpCircleLine"
      iconColor="Grey40"
      size="medium"
      #helpAndSupportPopover="ngbPopover"
      [ngbPopover]="helpAndSupportTemplate"
      [animation]="false"
      triggers="manual"
      container="body"
      [disablePopover]="displayMode() === 'OVERLAY'"
      [selected]="isHelpMenuOpen() || helpAndSupportPopover.isOpen()"
      (click)="displayMode() === 'OVERLAY' ? helpButtonClicked.emit() : helpAndSupportPopover.toggle()"
    >
      Help & Support
    </button>
  </div>

  <ng-template #helpAndSupportTemplate>
    <ftr-help-sub-menu-flyout-card />
  </ng-template>
} @else {
  <div class="header-logged-out-legacy row align-items-center justify-content-center">
    <ftr-logo [theme]="logoThemes.Themed" [size]="logoSizes.Legacy" />
    <div class="help-button">
      <button ftrTooltip message="Help Center" [showDash]="false" alignment="center" position="left" ftrElevioTrigger>
        <svg ftrIcon="HelpCircleSolid" iconColor="Primary50" [iconSize]="28" class="align-top"></svg>
      </button>
    </div>
  </div>
}
